export enum UserOverlayTypes {
  SetSegmentDefinition = 'UserOverlay.setSegmentDefinition',
  DeleteUserRequest = 'UserOverlay.deleteUser.Request',
  DeleteUserSuccess = 'UserOverlay.deleteUser.Success',
  DeleteUserFailure = 'UserOverlay.deleteUser.Failure',
  QueryUserRequest = 'UserOverlay.queryUser.Request',
  QueryUserSuccess = 'UserOverlay.queryUser.Success',
  QueryUserFailure = 'UserOverlay.queryUser.Failure',
  ExportUserRequest = 'UserOverlay.exportUser.Request',
  ExportUserSuccess = 'UserOverlay.exportUser.Success',
  ExportUserFailure = 'UserOverlay.exportUser.Failure',
  UserDetailsMatchingRequest = 'UserOverlay.userDetails.Matching.Request',
  UserDetailsMatchingSuccess = 'UserOverlay.userDetails.Matching.Success',
  UserDetailsMatchingFailure = 'UserOverlay.userDetails.Matching.Failure',
  UserDetailsAllSessionsRequest = 'UserOverlay.userDetails.AllSessions.Request',
  UserDetailsAllSessionsSuccess = 'UserOverlay.userDetails.AllSessions.Success',
  UserDetailsAllSessionsFailure = 'UserOverlay.userDetails.AllSessions.Failure',
}
